<div>
  <table class="custom-table-list w-100" aria-label="material_group_table">
    <thead>
      <tr class="custom-table-list-headings">
        <th class="custom-col-width-30" scope="col">Name</th>
        <th class="custom-col-width-25" scope="col">Material Code</th>
        <th class="custom-col-width-20" scope="col">Status</th>
        <th class="custom-col-width-25 th-last" scope="col">Created On</th>
      </tr>
    </thead>
    <tbody>
      @for (materialGroup of materialGroups; track materialGroup._id) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-30">
            <div class="text-truncate" appEllipsisTooltip [ngbTooltip]="materialGroup.name"
              [placement]="'top'">{{ materialGroup.name }}</div>
          </td>
          <td class="custom-col-width-25">
            <div class="text-truncate" appEllipsisTooltip [ngbTooltip]="materialGroup.materialCode"
              [placement]="'top'">{{ materialGroup.materialCode || '-' }}</div>
          </td>
          <td class="custom-col-width-20">{{ materialGroup.status || '-' }}</td>
          <td class="custom-col-width-25 td-last">{{ materialGroup.created | date:'dd MMM yy' }}</td>
        </tr>
      }
      @if (loadRecords) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            <app-common-icon [loadingIcon]="loadRecords"></app-common-icon>
          </td>
        </tr>
      }
      @if (!loadRecords && materialGroups.length === 0) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-100 text-danger d-flex justify-content-center">
            No Data Found
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="overlay" [class.show]="isPanelOpen"></div>
@if (isPanelOpen) {
  <div class="off-canvas width-450" [class.show]="isPanelOpen">
    <div class="off-canvas-content">
      <app-offcanvas-header header="Add Material Group" (closeClicked)="closeAddPanel()"></app-offcanvas-header>
      <div class="offCanvas__container">
        <div class="offCanvas__contentWrapper">
          <form class="mt-2" [formGroup]="materialGroupFormGroup">
            <div class="offcanvas__content">
              <div class="offcanvas__orgDetails">
                <div class="offCanvas__orgName-inputField">
                  <app-input-filed label="Name" placeholder="Enter Name" [starIcon]="'*'"
                  [control]="$any(materialGroupFormGroup).controls['name']"></app-input-filed>
                  @if (materialGroupFormGroup.get('name')?.invalid &&
                    (materialGroupFormGroup.get('name')?.dirty ||
                    materialGroupFormGroup.get('name')?.touched)) {
                    <div>
                      @if (materialGroupFormGroup.get('name')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Name is required.</small>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="offCanvas__orgName-inputField mt-3">
                  <app-input-filed label="Material Code" placeholder="Enter Material Code" [starIcon]="'*'"
                    [toUpperCase]="true"
                  [control]="$any(materialGroupFormGroup).controls['materialCode']"></app-input-filed>
                  @if (materialGroupFormGroup.get('materialCode')?.invalid &&
                    (materialGroupFormGroup.get('materialCode')?.dirty ||
                    materialGroupFormGroup.get('materialCode')?.touched)) {
                    <div>
                      @if (materialGroupFormGroup.get('materialCode')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Material Code is required.</small>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (errorMessage) {
                  <p class="text-danger m-2">{{errorMessage}}</p>
                }
              </div>
            </div>
          </form>
        </div>
        <div class="offCanvas__footer">
          <app-common-button (clickEvent)="closeAddPanel()" buttonClass="smallbutton"
          buttonLabel="Cancel"></app-common-button>
          @if (commonService.orgLock()) {
            <app-common-button (clickEvent)="onSubmit()" [loadingIcon]="verifyLoader"
              buttonClass="smallFilledButton" buttonLabel="Save"
            [disabled]="materialGroupFormGroup.invalid"></app-common-button>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (isErrorToster) {
  <div class="toaster_message">
    <app-error-toaster [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-error-toaster>
  </div>
}

@if (isSuccessToster) {
  <div class="toaster_message">
    <app-toast [title]="tosterMessage" (closeToaster)="closingToster($event)"></app-toast>
  </div>
}
